module.exports = __webpack_public_path__ + "static/img/miPad4Plus.e37a6f74.png";